const Style = {

  app: 'p-8 min-h-full bg-slate-100 transition-all duration-300 ease-in-out md:pl-32',
  appExpanded: 'md:pl-56',

};

export default Style;